import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Distribution = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-7vh'}}>Distribution</Paragraph>
        <Text className='BaseText2'>Our product could be marketed as a non-prescription device, distributed in public health centers from Mexico’s National Health Agency (Secretaría de Salud). This would promote easier access to iMoAge for a larger portion of the population and the social impact would be larger than through any other distribution channel (this was an insight from our Human Practices section). This agency already has testing programmes for specific diseases such as diabetes. Taking this into account, in an interview with the Procurement Subdirector of Secretaría de Salud we confirmed that our test could be used in the same way, and outlined a roadmap for it’s distribution, as shown in the next image.</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/project-implementation/roadmap.png'/>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Distribution;
